import type { CheckoutOption } from "./projectCheckoutOptions";
import type { ProjectGroupRemovalTarget } from "./projectGroupRemovalRunner";
import { classifyEnvironmentId } from "./environments/environmentIdClassification";

export function resolveProjectGroupRemovalTargets(input: {
  readonly checkouts: readonly CheckoutOption[];
  readonly selected: CheckoutOption | null;
  readonly mode: "checkout" | "project" | null;
  readonly threadCountByCheckoutValue: ReadonlyMap<string, number>;
}): readonly ProjectGroupRemovalTarget[] {
  const checkouts =
    input.mode === "checkout" && input.selected ? [input.selected] : input.checkouts;
  return checkouts.map((checkout) => ({
    environmentId: checkout.environmentId,
    projectId: checkout.projectId,
    label: checkout.shortLabel,
    path: checkout.workspaceRoot,
    threadCount: input.threadCountByCheckoutValue.get(checkout.value) ?? 0,
    kind: classifyEnvironmentId(checkout.environmentId).isCloud ? "cloud" : "local",
  }));
}
